export default "__VITE_ASSET__41ec48b2__"